// removed by extract-text-webpack-plugin
module.exports = {"ChatFooterEmojiButton":"ChatFooterEmojiButton__1T1Pn","CancelButton":"CancelButton__3Nr82","Spinner":"Spinner__3FtXd","ChatFooterSendButton":"ChatFooterSendButton__Tnfqp","ChatFooterButtons":"ChatFooterButtons__26eZL","FileBubble":"FileBubble__1HwDg","TextArea":"TextArea__24Z1F","ChatFooter":"ChatFooter__1p0cJ","ChatTextarea":"ChatTextarea__1ia1p"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/Chat/ChatFooter/style.scss
// module id = +RxT
// module chunks = 0